"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const typography = {
  font: {
    component: {
      heading: {
        xxs: {
          fontWeight: 700,
          fontSize: '0.625em',
          lineHeight: 1.2,
          letterSpacing: '0.08em',
          textTransform: 'uppercase'
        },
        xs: {
          fontWeight: 600,
          fontSize: '1em',
          lineHeight: 1.25,
          textTransform: 'none'
        },
        sm: {
          fontWeight: 700,
          fontSize: '1.25em',
          lineHeight: 1.2,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        },
        md: {
          fontWeight: 700,
          fontSize: '1.5em',
          lineHeight: 1.166666667,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        },
        lg: {
          fontWeight: 700,
          fontSize: '2em',
          lineHeight: 1.125,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        },
        xl: {
          fontWeight: 700,
          fontSize: '2.5em',
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        },
        xxl: {
          fontWeight: 700,
          fontSize: '3em',
          lineHeight: 1,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        },
        xxxl: {
          fontWeight: 700,
          fontSize: '4em',
          lineHeight: 1,
          letterSpacing: '-0.03em',
          textTransform: 'none'
        }
      },
      label: {
        xxs: {
          fontSize: '0.563125em',
          lineHeight: 1.331853496,
          letterSpacing: '0.04em',
          textTransform: 'uppercase'
        },
        xs: {
          fontSize: '0.625em',
          lineHeight: 1.2,
          letterSpacing: '0.04em',
          textTransform: 'uppercase'
        },
        sm: {
          fontSize: '0.75em',
          lineHeight: 1.333333333,
          textTransform: 'none'
        },
        md: {
          fontSize: '0.875em',
          lineHeight: 1.142857143,
          textTransform: 'none'
        },
        lg: {
          fontSize: '1em',
          lineHeight: 1.25,
          textTransform: 'none'
        },
        xl: {
          fontSize: '1.125em',
          lineHeight: 1.111111111,
          textTransform: 'none'
        },
        xxl: {
          fontSize: '1.5em',
          lineHeight: 1.166666667,
          letterSpacing: '-0.02em',
          textTransform: 'none'
        }
      },
      text: {
        xs: {
          fontSize: '0.625em',
          lineHeight: 1.6
        },
        xsLead: {
          fontSize: '0.75em',
          lineHeight: 1.666666667
        },
        sm: {
          fontSize: '0.75em',
          lineHeight: 1.333333333
        },
        smLead: {
          fontSize: '1em',
          lineHeight: 1.5
        },
        md: {
          fontSize: '0.875em',
          lineHeight: 1.428571429
        },
        mdLead: {
          fontSize: '1.125em',
          lineHeight: 1.555555556
        },
        lg: {
          fontSize: '1em',
          lineHeight: 1.5
        },
        lgLead: {
          fontSize: '1.25em',
          lineHeight: 1.6
        }
      },
      root: {
        fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
        fontSize: '100%'
      }
    },
    global: {
      family: {
        brand: {
          name: 'Poppins'
        },
        system: {
          name: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
        }
      },
      letterSpacing: {
        none: '0em',
        denser: '-0.03em',
        dense: '-0.02em',
        loose: '0.04em',
        looser: '0.08em'
      },
      size: {
        '20': '0.5625em',
        '40': '0.625em',
        '60': '0.75em',
        '80': '0.875em',
        '100': '1em',
        '200': '1.125em',
        '300': '1.25em',
        '400': '1.5em',
        '500': '2em',
        '600': '2.5em',
        '700': '3em',
        '800': '4em',
        html: '100%'
      },
      style: {
        normal: 'normal',
        italic: 'italic'
      },
      weight: {
        thin: 100,
        extralight: 200,
        light: 300,
        regular: 400,
        medium: 500,
        semibold: 600,
        bold: 600,
        extrabold: 700,
        black: 900,
        extrablack: 950
      }
    }
  },
  fontFace: {
    import: 'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;0,800;1,400&display=fallback'
  }
};
var _default = exports.default = typography;